import React from 'react';
import { Viewer, SpecialZoomLevel, ToolbarSlot, ToolbarProps } from '@react-pdf-viewer/core';
import { Box, Stack, Card, Grid } from '@mui/material';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const renderToolbar = (additionalToolbarChildren=null) => (Toolbar: (props: ToolbarProps) => ReactElement) => (
    <Toolbar>
        {(slots: ToolbarSlot) => {
            const {
                Download,
                EnterFullScreen,
                Zoom,
                ZoomIn,
                ZoomOut,
            } = slots;
            return (
                <Grid container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      width="100%"
                      component={Card}
                      elevation={1}
                      sx={{
                          px: 2,
                          py: 0.5,
                      }}>
                    <Grid item xs={0} md="auto">
                        {
                            additionalToolbarChildren
                            ? additionalToolbarChildren
                            : <Box flexItem/>
                        }
                    </Grid>
                    <Grid item
                          xs={12}
                          md="auto">
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            spacing={1}
                        >
                            <ZoomOut />
                            <Zoom />
                            <ZoomIn />
                            <EnterFullScreen />
                            <Download />
                        </Stack>
                    </Grid>
                </Grid>
            );
        }}
    </Toolbar>
);

export default function MyPdfViewer({fileUrl, additionalToolbarChildren=null}) {
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        sidebarTabs: () => [],
        renderToolbar: renderToolbar(additionalToolbarChildren),
    });

    return (
        <Box
            component={Card}
            elevation={1}
            sx={{
                width: '100%',
                height: '100%',
                position: 'relative',
                '& .rpv-default-layout__toolbar': {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    py: 0,
                    backgroundColor: 'transparent',
                    border: 'none',
                },
                '& .rpv-default-layout__container': {
                    border: 'none',
                },
                '& .rpv-default-layout__main': {
                    mt: '42px',
                    overflowY: 'auto',
                },
            }}
        >
            <Viewer
                plugins={[defaultLayoutPluginInstance]}
                defaultScale={SpecialZoomLevel.PageWidth}
                fileUrl={fileUrl}
            />
        </Box>
    );
}
